import { useEffect, useRef, useState } from 'react';
import { STYLE, MARKUP } from './sqlEditor.markup.js';
import { mountSqlEditor } from './sqlEditor.logic.js';
import ReplicatePage from './ReplicatePage.jsx';
import ExportPage from './ExportPage.jsx';
import OrbitModuleHeader from '../../shared/hub/OrbitModuleHeader.jsx';

function LegacyEditor() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    root.innerHTML = MARKUP;
    let cleanup;
    try { cleanup = mountSqlEditor(root); } catch (e) { console.error(e); }
    return () => {
      try { cleanup && cleanup(); } catch {}
      if (root) root.innerHTML = '';
    };
  }, []);

  return (
    <>
      <style>{STYLE}</style>
      <div ref={ref} />
    </>
  );
}

const TABS = [
  { id: 'editor', label: 'SQL Editor', render: () => <LegacyEditor /> },
  { id: 'replicate', label: 'Replicate to Test', render: () => <ReplicatePage /> },
  { id: 'export', label: 'Export to SQL', render: () => <ExportPage /> },
];

function readTab() {
  return window.location.pathname.slice('/sql-editor/'.length) || 'editor';
}

export default function SqlEditorPage() {
  const [tab, setTab] = useState(readTab);
  const active = TABS.find(t => t.id === tab) || TABS[0];

  useEffect(() => {
    const onPop = () => setTab(readTab());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  function navigateTab(id) {
    history.pushState(null, '', id === 'editor' ? '/sql-editor' : `/sql-editor/${id}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  return (
    <div>
      <OrbitModuleHeader title="SQL Query Tool" tabs={TABS} activeTab={active.id} onTabChange={navigateTab} />
      {active.render()}
    </div>
  );
}
